import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { CompanyInfoDetailSection } from './styled';
import { Time } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';

import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';

interface ServiceHour {
  week: string;
  fromAt: string;
  toAt: string;
}

const CompanyServiceHour: React.FunctionComponent = () => {
  const { serviceHourList, serviceHourEntry } = useStyles();
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;
  const serviceHour = partnerInfo?.serviceHours
    ? partnerInfo?.serviceHours
    : '';
  const parsedServiceHour: ServiceHour[] = serviceHour
    ? JSON.parse(serviceHour)
    : [];

  if (!serviceHour) return null;

  return (
    <CompanyInfoDetailSection>
      <div className="data-row">
        <div className="row-title">
          <Time size={20} />
          <CustomizedTypography variant="body2">대응시간</CustomizedTypography>
        </div>

        <div className={serviceHourList}>
          {!serviceHour && (
            <CustomizedTypography className="no-data">
              업데이트 예정
            </CustomizedTypography>
          )}
          {parsedServiceHour &&
            parsedServiceHour.map((item, index) => (
              <div className={serviceHourEntry} key={index}>
                <CustomizedTypography
                  variant="body2"
                  fontWeight="500"
                  color="textPrimary"
                >
                  {item.week} {item.fromAt} {item.toAt}
                </CustomizedTypography>
              </div>
            ))}
        </div>
      </div>
    </CompanyInfoDetailSection>
  );
};

export default CompanyServiceHour;

const useStyles = makeStyles((theme) => ({
  serviceHourList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  serviceHourEntry: {}
}));
